var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeoServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Service Image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Service Image_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31 15.5L34.4 19L23.2 30.3C17 36.5 12 42 12 42.6C12 43.9 16.2 48 17.5 48C18.1 48 23.5 43 29.7 36.8L41 25.6L44.5 29L48 32.4V22.2V12H37.8H27.6L31 15.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M72 48V84H78H84V48V12H78H72V48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52 64V84H58H64V64V44H58H52V64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32 72V84H38H44V72V60H38H32V72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12 76V84H18H24V76V68H18H12V76Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoServices);
export default __webpack_public_path__ + "static/media/seo-services.fb0015df799be0304e2f92a52c6c8e09.svg";
export { ForwardRef as ReactComponent };